import { useEffect, useState } from 'react';

/** Typing pause before the API is asked for lists by name. */
export const SEARCH_PAUSE_MS = 300;

/** `value`, once it has stopped changing for `ms`: one request per pause in typing, not per key. */
export const useDebounced = <T>(value: T, ms = SEARCH_PAUSE_MS): T => {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return settled;
};
